import { useCallback, useMemo } from "react";

import { get } from "lodash";
import moment from "moment";
import { useFormState } from "react-final-form";

/**
 * Questo hook restituisce una funzione che prende in input un record qualsiasi
 * e compara la sua data di modifica con l'eventuale data di ultimo inoltro della
 * proposta. Se la data di ultimo inoltro è null (per esempio quando il progetto)
 * è in stato bozza oppure maggiore della data del record, la funzione restituirà
 * false ad indicare che non si possiedono i permessi necessari per manipolare il
 * record specificato, in caso contrario true.
 */
const useTimePermission = () => {
  const formState = useFormState();
  const lastSent = useMemo(() => {
    const ls = get(formState.values, "last_sent", null);
    if (ls === null) {
      return null;
    }
    return moment(ls);
  }, [formState.values]);
  return useCallback(
    (record) => {
      if (lastSent === null) {
        return true;
      }
      const modified = get(record, "modified", null);
      if (modified === null) {
        // Il record è sempre modificabile poichè
        // la sua struttura non prevede date di creazione/modifica.
        return true;
      }
      const dt = moment(modified);
      return dt.isAfter(lastSent);
    },
    [lastSent]
  );
};
export default useTimePermission;
